<div class="virus-detection-container" [attr.data-automation-id]="automationId + '-container'" [resBusySpinner]="isBusy"
    message="Loading ...">
    <div class="top-row">
        <res-custom-checkbox *ngIf="isStorageDepotConfigured"
            [automationId]="automationId + '-automatic-update-checkbox'" [(ngModel)]="isAutoUpdateEnabled"
            (ngModelChange)="onIsAutoUpdateChanged()"
            content=" Update Virus Detection automatically (every day at 2 AM)"
            [disabled]="isUpdating || !hasCreatePermissions">
        </res-custom-checkbox>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <div [ngClass]="{'update-row-no-storage': !isStorageDepotConfigured}">
        <label [attr.data-automation-id]="automationId + '-current-version'">Current version: {{versionNumber}}</label>
        <button type="button" [attr.data-automation-id]="automationId + '-update-button'"
            class="secondary-button update-button" (click)="updateVirusDefinitions()" *ngIf="hasCreatePermissions"
            [disabled]="isUpdating || !isStorageDepotConfigured">
            <i [ngClass]="isUpdating && isStorageDepotConfigured? 'fa fa-spinner fa-spin' : 'fa fa-refresh'"
                [attr.data-automation-id]="automationId + '-update-icon'"></i>{{isUpdating &&
            isStorageDepotConfigured?'Updating' : 'Update Now'}}
        </button>
        <label class="last-updated-label" [ngClass]="{'padding-label': !hasCreatePermissions}"
            [attr.data-automation-id]="automationId + '-last-updated'">Last updated:
            {{lastUpdatedDateTime === defaultLabel ? defaultLabel : (lastUpdatedDateTime | date:'yyyy-MM-dd
            HH:mm:ss')}}</label>
    </div>
    <span [ngClass]="{'status-row-no-storage': !isStorageDepotConfigured}"
        [attr.data-automation-id]="automationId + '-status-message'">
        Status: {{updateStatus}}
    </span>
</div>